import { inject } from '@angular/core';
import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import Keycloak from 'keycloak-js';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function authInterceptor(req: HttpRequest<any>, next: HttpHandlerFn) {
  const config = inject(ConfigService);

  if (req.url.endsWith('/Logs')) {
    return next(req);
  }

  // API in Header schreiben
  let key = req.clone({
    headers: req.headers.append('X-API-KEY', config.apiKey),
  });

  const keycloak: Keycloak = inject(Keycloak);

  // Token in Header schreiben
  if (keycloak.authenticated && keycloak.token !== undefined) {
    key = key.clone({
      headers: key.headers.append('Authorization', `Bearer ${keycloak.token}`),
    });
  }

  return next(key);
}
